import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { TreeListDto } from '@lib/dto/tree.dto'
import { treeService } from '@/services/TreeService'
import { treeKeys } from '@/hooks/queryKeys'

/**
 * Server truth for a site's trees.
 *
 * `retry: false` and no background refetching, unlike the app's other lists.
 * This query feeds a screen that keeps its own authoritative local copy: when
 * the network is down the right behavior is to fail once, quietly, and let the
 * cached survey carry on — not to retry into a dead radio while someone is
 * trying to record a tree.
 */
export function useTrees(
  siteId: string,
  /** Whose findings to show: a visit, or null for the site's current one. */
  visitId: string | null = null,
  enabled = true,
): UseQueryResult<TreeListDto> {
  return useQuery({
    queryKey: treeKeys.list(siteId, visitId),
    queryFn: () => treeService.listBySite(siteId, false, visitId),
    enabled: enabled && siteId !== '',
    retry: false,
    staleTime: 30_000,
  })
}
